import { ROUTES, isPublicMount } from "../../../routes";

/**
 * Propulsion calculator paths.
 *
 * Mounts twice: publicly at `<base>/public` and inside the app at `<base>`.
 * `PublicPropulsion` is the component both mounts share, so its links go through
 * `basePath()` — see logAnalyzer/paths.js for why.
 *
 * The builder, catalog, compare and saved-combination routes are app-only: they
 * read or write org-scoped data, so they have no public counterpart and are
 * always reached behind `requireSignin`.
 */
export const APP_BASE = ROUTES.propulsionCalc;
export const PUBLIC_BASE = `${APP_BASE}/public`;

export const basePath = (pathname = window.location.pathname) =>
  pathname.startsWith(PUBLIC_BASE) ? PUBLIC_BASE : APP_BASE;

/** The live calculator inside the app. Same component as the public mount. */
export const NEW_PATH = `${APP_BASE}/new`;

/**
 * The live calculator, for links arriving from ANOTHER feature (motor-data
 * offering "open the calculator"). Uses `isPublicMount` rather than this
 * feature's own base, because the caller's pathname belongs to that other
 * feature — see routes.js.
 */
export const calculatorPath = (pathname) => (isPublicMount(pathname) ? PUBLIC_BASE : NEW_PATH);

export const CLASSIC_PATH = `${NEW_PATH}/classic`;
export const CATALOG_PATH = `${APP_BASE}/catalog`;
export const COMPARE_PATH = `${APP_BASE}/compare`;

export const comboPath = (id) => `${APP_BASE}/${id}`;
export const compareWithPath = (id) => `${NEW_PATH}?comparison=${id}`;
export const compareIdsPath = (ids) => `${COMPARE_PATH}?ids=${ids}`;
